import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const timetableCategories = this.element.querySelectorAll('.timetable-categories .cat');

        this.setOverlayHeight();
        this.toggleCancelWorkout();
        this.initTooltip();

        timetableCategories.forEach(cat => {
            cat.addEventListener('click', () => {
                timetableCategories.forEach(category => {
                    category.classList.remove('active');
                });

                this.toggleTab(cat);
            })
        })
    }

    toggleCancelWorkout() {
        const defaultButtons = this.element.querySelectorAll('.cancel-workout-form button.btn-register');

        defaultButtons.forEach(defaultButton => {
            defaultButton.addEventListener('mouseenter', () => {
                defaultButton.querySelector('.default-text').classList.add('hidden');
                defaultButton.querySelector('.cancel-text').classList.remove('hidden');
                defaultButton.classList.remove('registered');
            })

            defaultButton.addEventListener('mouseleave', () => {
                defaultButton.querySelector('.default-text').classList.remove('hidden');
                defaultButton.querySelector('.cancel-text').classList.add('hidden');
                defaultButton.classList.add('registered');
            })
        })
    }

    setOverlayHeight() {
        const highlighted = this.element.querySelector('.timetable-data table thead tr th.highlight');
        const table = this.element.querySelector('.timetable-data table');
        const overlay = highlighted.querySelector('.overlay');

        overlay.style = 'bottom: -' + (table.offsetHeight - 66) + 'px';
    }

    initTooltip() {
        const tooltips = document.querySelectorAll('[data-tooltip]');

        tooltips.forEach(tooltip => {
            const tooltipBox = tooltip.parentNode.querySelector('.tooltip');
            tooltip.addEventListener('mouseenter', () => {
                tooltipBox.classList.add('active');
                tooltipBox.innerHTML = tooltip.dataset.tooltip;

                if (tooltipBox) {
                    tooltipBox.querySelector('.btn-tooltip').addEventListener('click', (e) => {
                        e.preventDefault();

                        document.querySelector('.expand-login').click();
                    })
                }

                document.onmouseover = (e) => {
                    const target = e.target;

                    if (target === tooltipBox ||
                        target === tooltipBox.querySelector('.btn-tooltip') ||
                        target.parentNode === tooltipBox.parentNode.parentNode ||
                        target === tooltipBox.parentNode.parentNode
                    ) {} else {
                        tooltipBox.classList.remove('active');
                    }

                }
            })
        })

    };

    toggleTab(tab) {
        const cellData = this.element.querySelectorAll('.cell-data');
        const rows = this.element.querySelectorAll('tbody tr');

        tab.classList.add('active');
        const catData = tab.dataset.cat;

        cellData.forEach(cData => {
            cData.classList.remove('hidden');
        });

        cellData.forEach(cell => {
            if (catData === 'all') {
                return;
            }

            if (catData !== cell.dataset.cat) {
                cell.classList.add('hidden');
            }
        });

        rows.forEach(row => {
            row.classList.remove('hidden');
        });

        rows.forEach(row => {
            const hidden = row.querySelectorAll('td .cell-data.hidden');
            const visible = row.querySelectorAll('td .cell-data');

            if (hidden.length === visible.length) {
                row.querySelector('td .cell-data.hidden').parentNode.parentNode.classList.add('hidden');
            }
        });

        this.setOverlayHeight();
    }
}
